import { render, staticRenderFns } from "./ModificaOggetto.vue?vue&type=template&id=d7573a26&scoped=true&"
import script from "./ModificaOggetto.vue?vue&type=script&lang=js&"
export * from "./ModificaOggetto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7573a26",
  null
  
)

export default component.exports